import { useEffect, useState } from 'react';
import { settingsAPI } from '../services/api';
import { DEFAULT_WO_TIMES } from '../utils/workOrderModel';

/**
 * Reads default WO start/end times from Quote Defaults settings (§0.5).
 * Used by the WO range picker (§1.2) and calendar quick-create.
 */
export default function useSchedulingDefaults() {
  const [defaults, setDefaults] = useState(DEFAULT_WO_TIMES);

  useEffect(() => {
    let active = true;
    settingsAPI
      .getQuoteDefaults()
      .then((res) => {
        if (!active || !res) return;
        setDefaults({
          startTime: res.wo_default_start_time || DEFAULT_WO_TIMES.startTime,
          endTime: res.wo_default_end_time || DEFAULT_WO_TIMES.endTime,
        });
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  return defaults;
}
